import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import TermsGate from "@/components/TermsGate";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";

import Welcome from "@/pages/Welcome";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Track from "@/pages/Track";
import PartnerQuote from "@/pages/customer/PartnerQuote";
import PaintOrder from "@/pages/customer/PaintOrder";
import PaintHistory from "@/pages/customer/PaintHistory";
import PaintCustomers from "@/pages/customer/PaintCustomers";
import VerifyEmail from "@/pages/VerifyEmail";
import ResetPassword from "@/pages/ResetPassword";
import AuthCallback from "@/pages/AuthCallback";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import CustomerDashboard from "@/pages/customer/CustomerDashboard";
import NewBooking from "@/pages/customer/NewBooking";
import BulkBooking from "@/pages/customer/BulkBooking";
import FloristBooking from "@/pages/customer/FloristBooking";
import FloristHistory from "@/pages/customer/FloristHistory";
import OrderDetail from "@/pages/customer/OrderDetail";
import DriverDashboard from "@/pages/driver/DriverDashboard";
import DriverBoard from "@/pages/driver/DriverBoard";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import QuoteBuilder from "@/pages/QuoteBuilder";
import QuoteView from "@/pages/QuoteView";
import ManifestScan from "@/pages/ManifestScan";
import DriverRoute from "@/pages/DriverRoute";

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading || user === null) return null;
  if (!user) return <Welcome />;
  return <Navigate to={user.role === "admin" ? "/admin" : user.role === "driver" ? "/driver" : "/dashboard"} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/login" element={<Welcome />} />
            <Route path="/register" element={<Welcome />} />
            <Route path="/welcome" element={<Welcome />} />
            <Route path="/track/:trackingNumber" element={<Track />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/dashboard" element={<ProtectedRoute roles={["customer", "admin"]}><CustomerDashboard /></ProtectedRoute>} />
            <Route path="/book" element={<ProtectedRoute roles={["customer", "admin"]}><NewBooking /></ProtectedRoute>} />
            <Route path="/partner" element={<ProtectedRoute roles={["customer"]}><PartnerQuote /></ProtectedRoute>} />
            <Route path="/paint" element={<ProtectedRoute roles={["customer", "admin"]}><PaintOrder /></ProtectedRoute>} />
            <Route path="/paint/history" element={<ProtectedRoute roles={["customer", "admin"]}><PaintHistory /></ProtectedRoute>} />
            <Route path="/paint/customers" element={<ProtectedRoute roles={["customer", "admin"]}><PaintCustomers /></ProtectedRoute>} />
            <Route path="/book/bulk" element={<ProtectedRoute roles={["customer", "admin"]}><BulkBooking /></ProtectedRoute>} />
            <Route path="/book-flowers" element={<ProtectedRoute roles={["customer", "admin"]}><FloristBooking /></ProtectedRoute>} />
            <Route path="/flower-history" element={<ProtectedRoute roles={["customer", "admin"]}><FloristHistory /></ProtectedRoute>} />
            <Route path="/orders/:orderId" element={<ProtectedRoute><OrderDetail /></ProtectedRoute>} />
            <Route path="/driver" element={<ProtectedRoute roles={["driver", "admin"]}><DriverDashboard /></ProtectedRoute>} />
            <Route path="/quotes/new" element={<ProtectedRoute roles={["driver", "admin"]}><QuoteBuilder /></ProtectedRoute>} />
            <Route path="/manifest" element={<ProtectedRoute roles={["driver", "admin"]}><ManifestScan /></ProtectedRoute>} />
            <Route path="/driver/route" element={<ProtectedRoute roles={["driver", "admin"]}><DriverRoute /></ProtectedRoute>} />
            <Route path="/driver/board" element={<ProtectedRoute roles={["driver", "admin"]}><DriverBoard /></ProtectedRoute>} />
            <Route path="/q/:token" element={<QuoteView />} />
            <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
          <TermsGate />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
